import axios from 'axios'

const fetchEmailTemplates = async filter => {
  let url = `/api/v1/emailTemplates`
  if (filter) url = url + filter
  return await axios.get(url)
}

export default {
  fetchEmailTemplates
}
